const fmt = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtN = (n) => Number(n || 0).toLocaleString('en-US');

const StarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

const ViewArrowIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const ContractsIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="16" rx="2" /><line x1="7" y1="9" x2="17" y2="9" /><line x1="7" y1="14" x2="13" y2="14" />
  </svg>
);
const ClientsIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" />
  </svg>
);
const TodayIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 16 14" />
  </svg>
);
const LastMonthIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

function TopAppCard({ rank, app, stats }) {
  const isActive = stats.thisMonth > 0;
  const domainLabel = app.homepage || app.redirect_uri || null;

  return (
    <div className="top-app-card">
      <div className="top-app-head">
        <span className="top-app-rank">{rank}</span>
        <div className="top-app-id-col">
          <span className="top-app-num">App #{app.app_id}</span>
          <span className="top-app-domain">{domainLabel || 'No domain'}</span>
        </div>
        <span className={`top-app-status ${isActive ? 'on' : 'off'}`}>{isActive ? 'Active' : 'Inactive'}</span>
      </div>

      <div className="top-app-value">
        <span className="top-app-lbl">This Month</span>
        <strong>${fmt(stats.thisMonth)}</strong>
      </div>

      <div className="top-app-stats">
        <div className="top-app-stat">
          <span className="top-app-stat-icon"><ContractsIcon /></span>
          <div><span className="top-app-lbl">Contracts</span><strong>{fmtN(stats.transactions)}</strong></div>
        </div>
        <div className="top-app-stat">
          <span className="top-app-stat-icon"><ClientsIcon /></span>
          <div><span className="top-app-lbl">Clients</span><strong>{fmtN(stats.clients)}</strong></div>
        </div>
        <div className="top-app-stat">
          <span className="top-app-stat-icon"><TodayIcon /></span>
          <div><span className="top-app-lbl">Today</span><strong>${fmt(stats.today)}</strong></div>
        </div>
        <div className="top-app-stat">
          <span className="top-app-stat-icon"><LastMonthIcon /></span>
          <div><span className="top-app-lbl">Last Month</span><strong>${fmt(stats.lastMonth)}</strong></div>
        </div>
      </div>

      <div className="top-app-share">
        <div className="top-app-share-top">
          <span className="top-app-lbl">Share of total</span>
          <strong>{stats.sharePercent}%</strong>
        </div>
        <div className="top-app-bar-track">
          <div className="top-app-bar-fill" style={{ width: `${Math.min(stats.sharePercent, 100)}%` }} />
        </div>
      </div>
    </div>
  );
}

export default function TopApps({ apps = [], appStats = {}, onViewAll }) {
  const top = [...apps]
    .filter((a) => (appStats[a.app_id]?.thisMonth || 0) > 0)
    .sort((a, b) => (appStats[b.app_id]?.thisMonth || 0) - (appStats[a.app_id]?.thisMonth || 0))
    .slice(0, 3);

  if (top.length === 0) return null;

  return (
    <div className="top-apps-section">
      <div className="chart-header">
        <div className="chart-title">
          <span className="chart-title-icon"><StarIcon /></span>
          Top Performing Apps
        </div>
        {onViewAll && (
          <button className="chart-view-all" onClick={onViewAll}>
            View All Apps <ViewArrowIcon />
          </button>
        )}
      </div>

      <div className="top-apps-grid">
        {top.map((app, i) => (
          <TopAppCard key={app.app_id} rank={i + 1} app={app} stats={appStats[app.app_id]} />
        ))}
      </div>
    </div>
  );
}
